import { render, staticRenderFns } from "./professor-classe-estatistica.vue?vue&type=template&id=5a4a5333&"
import script from "./professor-classe-estatistica.vue?vue&type=script&lang=js&"
export * from "./professor-classe-estatistica.vue?vue&type=script&lang=js&"
import style0 from "./professor-classe-estatistica.vue?vue&type=style&index=0&id=5a4a5333&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports